export interface SaveAvatarParams {
  userNodeId: string;
  flagName: string;
  variantName: string;
  image: string;
  avatarFeedback?: {
    looksLikeMe: number;
    isInspiring: number;
  };
  saveToDatabase: (params: {
    userNodeId: string;
    flagName: string;
    variantName: string;
    payload: Record<string, unknown>;
  }) => Promise<boolean>;
}

export async function saveSelectedAvatar(params: SaveAvatarParams): Promise<{ success: boolean; error?: string }> {
  try {
    await params.saveToDatabase({
      userNodeId: params.userNodeId,
      flagName: params.flagName,
      variantName: params.variantName, // since there is no variant, will display as 'disabled'
      payload: {
        image: params.image,
        ...(params.avatarFeedback && {
          avatarFeedback: params.avatarFeedback,
        }),
      },
    });

    return { success: true };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Failed to save avatar',
    };
  }
}
